import { ReactNode, useCallback, useRef, useState } from "react";
import {
  Container,
  Content,
  ContentWrapper,
  AccordionHandle,
  SeriesName,
  AccordionItemWrap,
  ArrowImage,
} from "./elements";
import IPhone15Pro from "../../assets/images/iphone-15-pro.png";
import UP from "../../assets/images/arrow_up.svg";
import DOWN from "../../assets/images/arrow_down.svg";

interface Props {
  isSmall: boolean;
  title: string;
  children: ReactNode;
}

export const Accordion: React.FC<Props> = ({
  isSmall = false,
  title,
  children,
}) => {
  const [isExpanded, setExpand] = useState<boolean>(false);

  const contentRef = useRef<HTMLDivElement | null>(null);

  const heightStatus = isSmall ? "60px" : "111px";

  // const contentHeight = isExpanded ? contentRef.current?.scrollHeight || 0 : 0;
  const contentHeight = isExpanded ? contentRef.current?.scrollHeight || 0 : 0;
  const handleExpandToggle = useCallback(() => {
    setExpand(!isExpanded);
  }, [isExpanded]);

  return (
    <Container>
      <AccordionHandle
        onClick={handleExpandToggle}
        isExpanded={isExpanded}
        isSmall={isSmall}
      >
        <AccordionItemWrap>
          <SeriesName>{title}</SeriesName>
        </AccordionItemWrap>
        {isExpanded ? (
          <ArrowImage alt="arrow_up" src={UP} />
        ) : (
          <ArrowImage alt="arrow_down" src={DOWN} />
        )}
      </AccordionHandle>
      <ContentWrapper settingheight={contentHeight}>
        <Content ref={contentRef}>{children}</Content>
      </ContentWrapper>
    </Container>
  );
};

Accordion.displayName = "Accordion";
